import LaunchIconRounded from "@mui/icons-material/Launch";
import { Box, Chip, Typography } from "@mui/material";
import PercentageLabel from "../../frameworks/components/PercentageLabel"; // Assuming this is a custom component

const HeaderTechnique = ({
  openTechniqueUrl,
  colors,
  selectedTechnique,
  showRisk,
}) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center">
        <Typography sx={{ marginRight: "16px" }} variant="h5">
          {selectedTechnique?.name}
        </Typography>
        <PercentageLabel
          percentage={selectedTechnique?.percentage}
          negativePercentage={showRisk}
          tooltipTitle={
            showRisk
              ? "This number indicates the percentage of relevant entities currently at risk from this technique"
              : "This number indicates the percentage of relevant entities protected from this technique"
          }
        />
      </Box>
      <Chip
        clickable
        onClick={openTechniqueUrl}
        onMouseDown={openTechniqueUrl}
        sx={{
          borderRadius: "6px",
          color: "black",
          background: "none",
          "&:hover": {
            background: "none",
          },
        }}
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="overline">{selectedTechnique?.id}</Typography>
            <LaunchIconRounded sx={{ width: 16, height: 16 }} />
          </Box>
        }
      />
    </Box>
  );
};

export default HeaderTechnique;
